module.exports = __webpack_public_path__ + "img/lich_king_small.a17916b5.png";